export enum ClientChoreName {
  clientFileQualityCheck = 'client_file_quality_check',
}
